import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';
import { NamedLink, Icon } from '../../components';

import css from './ReviewsPage.module.css';

const SectionHero = props => {
  const { title, richTitle, listingId } = props;

  // title container
  const titleContainer = (
    <div className={css.titleContainer}>
      <h1 className={css.title}>{richTitle}</h1>
    </div>
  );

  const returnLink = (
    <NamedLink
      className={css.returnLink}
      name="ListingPage"
      params={{ id: listingId.uuid, slug: createSlug(title) }}
    >
      <Icon name="chevronLeft" className={css.returnLinkIcon} />
      <FormattedMessage id="ReviewsPage.returnText" />
    </NamedLink>
  );

  // top content
  const topContent = <div className={css.topContent}>{returnLink}</div>;

  return (
    <div className={css.sectionHero}>
      <div className={css.heroContent}>
        {topContent}
        {titleContainer}
      </div>
    </div>
  );
};

export default SectionHero;
